import axios from 'axios';
import { BookingState } from '@/stores/booking';

export class ConsultationRepo {
    constructor(
        protected config: any,
        protected client = axios.create({
            baseURL: config.public.apiEndpoint,
        })
    ) {}

    async getEnquiry(enquiry_id: string) {
        return await this.client.get(`/enquiry/${enquiry_id}`);
    }

    async getBooking(booking_id: string, business_id: string) {
        return await this.client.get(
            `/booking-appointment/${business_id}/get/${booking_id}`
        );
    }
    async getAvailability(state: any) {
        return await this.client.post('/availability', state);
    }
    async getBusiness(gym_name: string) {
        return await this.client.get(
            `/service/${encodeURIComponent(gym_name)}`
        );
    }
    async getNonCachedService(booking_business: string, service_id: string) {
        return await this.client.get(
            `/booking-business/${encodeURIComponent(booking_business)}/service/${encodeURIComponent(service_id)}`
        );
    }
    async createBooking(data: BookingState) {
        const endpoint = `/booking-appointment/${data.booking_business}/create`;
        return await this.client.post(endpoint, data);
    }
    async updateBooking(data: BookingState) {
        const endpoint = `/booking-appointment/${data.booking_business}/update/${data.booking_id}`;
        return await this.client.patch(endpoint, data);
    }
    async cancelBooking(data: BookingState) {
        const endpoint = `/booking-appointment/${data.booking_business}/cancel/${data.booking_id}`;
        return await this.client.post(endpoint, data);
    }
}
